export var Actions;
(function (Actions) {
    Actions["oneOff"] = "oneOff";
    Actions["autoRenewal"] = "autoRenewal";
})(Actions || (Actions = {}));
export var AutoRenewalStatus;
(function (AutoRenewalStatus) {
    AutoRenewalStatus["yes"] = "yes";
    AutoRenewalStatus["no"] = "no";
})(AutoRenewalStatus || (AutoRenewalStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRnVuZHNNYW5hZ2VyVHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJGdW5kc01hbmFnZXJUeXBlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksT0FHWDtBQUhELFdBQVksT0FBTztJQUNqQiw0QkFBaUIsQ0FBQTtJQUNqQixzQ0FBMkIsQ0FBQTtBQUM3QixDQUFDLEVBSFcsT0FBTyxLQUFQLE9BQU8sUUFHbEI7QUFFRCxNQUFNLENBQU4sSUFBWSxpQkFHWDtBQUhELFdBQVksaUJBQWlCO0lBQzNCLGdDQUFXLENBQUE7SUFDWCw4QkFBUyxDQUFBO0FBQ1gsQ0FBQyxFQUhXLGlCQUFpQixLQUFqQixpQkFBaUIsUUFHNUIifQ==